import { useEffect } from 'react';
import { Button, Flex, Result } from 'antd';
import { useNavigate, useRouteError } from 'react-router-dom';
import { errorReporter } from '@/shared/lib/errorReporter';
import { useBreakpoint } from '@/shared/lib/hooks';
import { fullScreenMinHeight, safeAreaPadding } from '@/shared/lib/mobileUi';

/** `errorElement` at the router root — catches anything a route/loader throws that
 *  `ErrorBoundary` (a render-time-only React boundary) wouldn't. */
export function ErrorPage() {
  const navigate = useNavigate();
  const error = useRouteError();
  const { isMobile } = useBreakpoint();

  useEffect(() => {
    errorReporter.captureException(error);
  }, [error]);

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{ minHeight: fullScreenMinHeight(isMobile), padding: isMobile ? safeAreaPadding(16) : 16 }}
    >
      {/* На узком экране у `Result` свои отступы 48/32 — сжимаем, чтобы текст не упирался в края. */}
      <Result
        status="error"
        title="Произошла ошибка"
        style={isMobile ? { padding: '24px 0', maxWidth: '100%' } : undefined}
        extra={
          <Button type="primary" size={isMobile ? 'large' : undefined} onClick={() => void navigate('/')}>
            На главную
          </Button>
        }
      />
    </Flex>
  );
}
